







































import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

import InfoBadge from '@/components/InfoBadge.vue';


@Component({
  name: 'try-to-fly-tariff',
  components: {
    InfoBadge,
  },
})
export default class TryToFlyTariff extends Vue {
  @Prop({ type: Boolean })
  private readonly isActivated!: boolean;
}
